import * as Url from "./Utils/UrlUtil";
import NotificationUtil from "./_notificationUtil"
import Interfaces from "./_interfaces";

import { OpenDocumentForRichEdit } from './_filingEdit';

const richTextEditorName: string = 'DxAspxRichTextEditor';
let isClose: boolean = false;

let keepSessionAlive: boolean;

export function SetKeepSessionAlive(value: boolean) {
    keepSessionAlive = value;
}

export function OnRichEditDocumentChanged() {
    keepSessionAlive = true;
}

export function RichEditorOnBeginCallback(s: ASPxClientRichEdit, e: MVCxClientBeginCallbackEventArgs) {
    e.customArgs['isClose'] = isClose;

    isClose = false;
}

export function DocumentSaveAndBack() {
    isClose = true;

    SaveRichEditDocument();

    let urlTemplate: string = window.ETDR_RD.appConfig['UrlTemplate.ProcessActionEdit'];
    let processActionId: number = $('#richedit-model-values').data('processaction-id');
    let url: string = Url.createUrlFromTemplate(urlTemplate, { processActionId: processActionId });

    location.href = url;
}

function SaveRichEditDocument() {
    let textEditor: ASPxClientRichEdit = window[richTextEditorName];

    if (!textEditor.HasUnsavedChanges()) {
        return;
    }

    let isSuccess: boolean = textEditor.commands.fileSave.execute();

    if (!isSuccess) {
        let errorText: string = 'Hiba történt a dokumentum mentése során!';
        NotificationUtil.Error(errorText);
        throw new Error(errorText);
    } else {
        console.log('RichEdit: Document saved');
    }
}

export function InitRichEditor(s: ASPxClientRichEdit, e) {
    s.SetFullscreenMode(true);

    let isIE: boolean = false || !!document['documentMode'];
    let isOldEdge: boolean = !isIE && !!window.StyleMedia;

    if (isIE || isOldEdge) {
        alert('Nem támogatott pár webes iratszerkesztő funkció (Mentés és vissza, bezárásnál dokumentum feloldása) Internet Explorer vagy Microsoft Edge böngészők alatt')
    }

    let statusBar: JQuery = $('#DxAspxRichTextEditor_Bar');
    let autosaveInformation: string = `<div>Automatikus mentés 60 másodpercenként. <span id="last-autosave-time">Még nem történt automatikus mentés.</span></div>`;
    statusBar.append(autosaveInformation);

    SetupSessionAndTransactionTimeoutExtender();

    // DX's RichEditor control uses a large z-index and couldn't find a solution to lower it, so raise the toast container's z-index to a higher value
    $('#toast-container').addClass('z-index10mil');
}

export function UnLockDocument() {
    let transactionGuid: string = $('#richedit-model-values').data('transaction-guid');

    $.ajax({
        method: "POST",
        url: window.ETDR_RD.appConfig["UrlAction.UnlockDocument"],
        data: {
            'transactionGuid': transactionGuid
        },
        headers: { Accept: 'application/json' }
    });
}

export function ForceUnLockDocumentAndOpenForEdit(processActionId: number, $editButton: JQuery) {
    let docGuid: string = $('#filingvars').data('document-guid');

    $.ajax({
        method: "POST",
        url: window.ETDR_RD.appConfig["UrlAction.ForceUnlockDocument"],
        data: {
            'documentGuid': docGuid
        },
        headers: { Accept: 'application/json' }
    })
        .done((response: Interfaces.BaseJsonResponse) => {
            if (response.success) {
                OpenDocumentForRichEdit(processActionId, $editButton);
            } else {
                NotificationUtil.Error(response.message);
            }
        })
        .fail((jqXHR: JQueryXHR) => {
            let errorText: string;

            if (jqXHR.responseJSON.message) {
                errorText = jqXHR.responseJSON.message;
            } else {
                errorText = 'Hiba történt a dokumentum feloldása során.';
            }

            NotificationUtil.Error(errorText);

            $('.doc-edit-btn').removeAttr('disabled');
        });
}

export function BeforeRichTextEditorUnloads() {
    UnLockDocument();
}

export function OnRichEditPopupMenuShowing(s: ASPxClientRichEdit, e: ASPxClientRichEditPopupMenuShowingEventArgs) {
    let spacingBeforeParagraph = {
        name: 'addSpacingBeforeParagraph',
        text: 'Térköz bekezdés előtt'
    } as ASPxClientRichEditPopupMenuItem;

    e.menuItems.Insert(0, spacingBeforeParagraph)

    let spacingAfterParagraph = {
        name: 'addSpacingAfterParagraph',
        text: 'Térköz bekezdés után'
    } as ASPxClientRichEditPopupMenuItem;

    e.menuItems.Insert(1, spacingAfterParagraph)

    let insertDateItemLong = {
        name: 'addDateLong',
        text: 'Aktuális dátum beillesztése (hosszú)'
    } as ASPxClientRichEditPopupMenuItem;

    let insertDateItemShort = {
        name: 'addDateShort',
        text: 'Aktuális dátum beillesztése (rövid)'
    } as ASPxClientRichEditPopupMenuItem;

    e.menuItems.Insert(2, insertDateItemShort);
    e.menuItems.Insert(3, insertDateItemLong);
}

export function OnRichEditCustomCommandExecuted(s: ASPxClientRichEdit, e: ASPxClientRichEditCustomCommandExecutedEventArgs) {
    switch (e.commandName) {
        case 'addSpacingBeforeParagraph':
            s.commands.addSpacingBeforeParagraph.execute();
            break;
        case 'addSpacingAfterParagraph':
            s.commands.addSpacingAfterParagraph.execute();
            break;
        case 'addDateLong':
            s.commands.insertText.execute(new Date().toLocaleString("hu-HU", { year: 'numeric', month: 'long', day: 'numeric' }));
            break;
        case 'addDateShort':
            s.commands.insertText.execute(new Date().toLocaleString("hu-HU", { year: 'numeric', month: 'numeric', day: 'numeric' }));
            break;
        case 'SaveAndBack':
            DocumentSaveAndBack();
            break;
    }
}

export function SetupSessionAndTransactionTimeoutExtender() {
    checkToKeepSessionAlive();

    function checkToKeepSessionAlive() {
        setTimeout(() => { sendSessionKeepAliveBeacon() }, 60 * 1000);
    }

    function sendSessionKeepAliveBeacon() {
        if (keepSessionAlive) {
            let transactionGuid: string = $('#richedit-model-values').data('transaction-guid');

            $.ajax({
                method: "POST",
                url: window.ETDR_RD.appConfig["UrlAction.SessionAndDocumentTransactionKeepAlive"],
                data: { transactionId: transactionGuid },
                headers: { Accept: 'application/json' }
            })
                .done((response: Interfaces.JsonResponseWithResult) => {
                    if (!response.success) {
                        let errorText: string;

                        if (response.message) {
                            errorText = response.message;
                        } else {
                            errorText = 'Hiba történt a dokumentum állapotának ellenőrzése során.';
                        }

                        NotificationUtil.Error(errorText);
                    }

                    if (response.result) {
                        checkToKeepSessionAlive();

                        SaveRichEditDocument();

                        displayLastAutoSaveTime();
                    } else {
                        NotificationUtil.Error(response.message);
                    }
                })
                .fail((jqXHR: JQueryXHR) => {
                    NotificationUtil.Error('Hiba történt a szerverrel történő kommunikáció során.');
                })
                .always(() => {
                    keepSessionAlive = false;
                });
        }
    }
}

function displayLastAutoSaveTime() {
    let displayPlace: JQuery = $('#last-autosave-time');
    let currentTime: string = new Date().toLocaleTimeString('hu-HU', { hour12: false, hour: "numeric", minute: "numeric", second: "numeric" });

    displayPlace.text(`Utolsó mentés időpontja: ${currentTime}`);
}

jQuery(() => {
    $('#richedit-body').on('mousemove', () => { SetKeepSessionAlive(true); });
    $('#richedit-body').on('keydown', () => { SetKeepSessionAlive(true); });
});
